import { useEffect, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const CanMove: React.FC = () => {
    const { t } = useLang('dpux.CanMove');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-CanMove');

    const list = [
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942963564/Move_pc2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943040426/Move_pc2.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942962701/Move_m2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943041214/Move_m2.webp',
            ),
            title: t('item2'),
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942963156/Move_pc1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943040156/Move_pc1.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942962487/Move_m1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943040718/Move_m1.webp',
            ),
            title: t('item1'),
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942962252/Move_pc3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943039916/Move_pc3.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942962887/Move_m3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943041006/Move_m3.webp',
            ),
            title: t('item3'),
        },
    ];

    /** 动画 */
    const sectionRef = useRef<HTMLDivElement>(null);
    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!infoRef.current || !sectionRef.current) return;
        if (typeof window !== 'undefined') {
            const sceneCArr: any[] = [];

            const title = sectionRef.current.querySelector('.title');
            const desc = sectionRef.current.querySelector('.desc');
            sceneCArr.push(
                AniContainer.create({
                    triggerElement: sectionRef.current,
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        title?.classList.add('enter');
                        desc?.classList.add('enter');
                    },
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            title?.classList.remove('enter');
                            desc?.classList.remove('enter');
                        }
                    },
                }),
            );
            if (window.innerWidth < 768) {
                sceneCArr.push(
                    AniContainer.create({
                        triggerElement: infoRef.current,
                        triggerHook: 1,
                        offset: '0%',
                        duration: '100%',
                        asyncFromTo: [
                            [`.delta-pro-ultra-x-CanMove .can-move-cards`, { opacity: 0 }, { opacity: 0 }, 0.55],
                            [`.delta-pro-ultra-x-CanMove .can-move-cards`, { opacity: 0 }, { opacity: 1 }, 0.3],
                            [`.delta-pro-ultra-x-CanMove .can-move-cards`, { opacity: 1 }, { opacity: 1 }, 0.3],
                        ],
                        asyncTimeLine: [0, 0.55, 1],
                    }),
                );
            } else {
                sceneCArr.push(
                    AniContainer.create({
                        triggerElement: `.delta-pro-ultra-x-CanMove .can-move-cards`,
                        triggerHook: 1,
                        offset: '0%',
                        duration: '200%',
                        asyncFromTo: [
                            [`.can-move-cards .card-item-1`, { y: 200 }, { y: -window.innerHeight / 5 }, 1.3],
                            [`.can-move-cards .card-item-0`, { y: 100 }, { y: -window.innerHeight / 6 }, 1.5],
                            [`.can-move-cards .card-item-2`, { y: 200 }, { y: -window.innerHeight / 4.5 }, 1.6],
                        ],
                        asyncTimeLine: [0, 0, 0],
                    }),
                );
            }

            return () => {
                sceneCArr.forEach((item: any) => item.destroy());
            };
        }
    }, []);

    return (
        <>
            <section
                className={`${css.section} delta-pro-ultra-x-CanMove GtmModuleData-section`}
                id="delta-pro-ultra-x-CanMove"
                data-section-id={'delta-pro-ultra-x-CanMove'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div ref={infoRef}>
                    <div className="title ani-1">{t('title')}</div>
                    <div className="desc ani-2">{t('desc')}</div>
                </div>
                <div className="can-move-cards">
                    {list.map((i, idx) => (
                        <div className={`card-item card-item-${idx}`} key={idx}>
                            <div className="img-box">
                                <EcoImg pc={i.pc} h5={i.h5} />{' '}
                            </div>
                            <span>{i.title}</span>
                        </div>
                    ))}
                </div>
            </section>
            {typeof window !== 'undefined' && window?.innerWidth >= 1024 && <EcoSpace />}
        </>
    );
};

export default CanMove;
